import {User} from '@hconnect/apiclient'
import {trackEvent} from '@hconnect/common/logging/Analytics'
import {Box, Button} from '@material-ui/core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {useLocation, useHistory} from 'react-router-dom'

import {JobSiteSelectionModal, useJobSiteSelectionModal} from '../../../features/rmc/orderIntake'
import {selectSelectedCustomerFilter} from '../../../Organisms/Customers/Customers.selector'
import {useRolesByCustomerId} from '../../../Roles'
import {AppState} from '../../../Root.store'
import {getUserProfile} from '../../../UserProfile/UserProfile.selectors'

import {useStyles} from './ScheduleNewDelivery'

export const ScheduleNewRMCDelivery = () => {
  const {t} = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()

  const selectedCustomer = useSelector((state: AppState) => selectSelectedCustomerFilter(state))
  const customerId = selectedCustomer?.customerId || ''
  const {data: roles} = useRolesByCustomerId(selectedCustomer?.customerId)
  const userProfile = useSelector<AppState, User | null>(
    (state) => getUserProfile(state).userProfile
  )

  const {
    isOpen,
    openModal,
    closeModal,
    handleJobSiteSelect,
    handleCreateNewOrder,
    handleRepeatPreviousOrder
  } = useJobSiteSelectionModal()

  // Check for auto-open parameter on component mount
  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.get('openJobsiteModal') === 'true') {
      // Remove the parameter from URL
      const newSearchParams = new URLSearchParams(location.search)
      newSearchParams.delete('openJobsiteModal')
      const newSearch = newSearchParams.toString()
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname

      // Replace current history entry to clean up URL
      history.replace(newUrl)

      // Track entry point as change jobsite
      trackEvent('hubRmcOrderIntakeStart', {
        product: 'hub',
        customerId: selectedCustomer?.customerId,
        customerName: selectedCustomer?.customerName,
        businessLine: 'RMC',
        userCountry: userProfile?.country,
        userId: userProfile?.user_id,
        role: roles?.map((role) => role.roleType).join(','),
        shippingType: 'DELIVER',
        entryPoint: 'ChangeJobsite'
      })

      // Open the modal
      openModal()
    }
  }, [location, history, openModal, selectedCustomer, userProfile, roles])

  const handleNewRMCDelivery = () => {
    // Track entry point event
    trackEvent('hubRmcOrderIntakeStart', {
      product: 'hub',
      customerId: selectedCustomer?.customerId,
      customerName: selectedCustomer?.customerName,
      businessLine: 'RMC',
      userCountry: userProfile?.country,
      userId: userProfile?.user_id,
      role: roles?.map((role) => role.roleType).join(','),
      shippingType: 'DELIVER',
      entryPoint: 'Overview'
    })

    openModal()
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <div className={classes.wrapper}>
          <Button
            color="primary"
            onClick={handleNewRMCDelivery}
            data-test-id="button-new-rmc-delivery"
          >
            {t('overview.scheduleNewRmcDelivery', 'New RMC delivery')}
          </Button>
        </div>
      </Box>

      <JobSiteSelectionModal
        open={isOpen}
        customerId={customerId}
        onClose={closeModal}
        onSelectSite={handleJobSiteSelect}
        onCreateNewOrder={handleCreateNewOrder}
        onRepeatPreviousOrder={handleRepeatPreviousOrder}
      />
    </>
  )
}
